/**
 * @file Lit l'activation de la demande d'avis restaurant et porte les libellés de son exclusion.
 * @module common.constants.restaurants.reviewRequests
 *
 * La demande d'avis peut être écartée à deux niveaux : sur une réservation
 * (`excludeFromReview` de la réservation) ou sur la fiche client
 * (`excludeFromReview` du client, qui couvre toutes ses réservations). Le
 * serveur vérifie les deux au moment de l'envoi, rappel compris.
 */

/**
 * Demande d'avis activée par l'établissement.
 *
 * Seule lecture de ce réglage côté écrans : la fiche réservation et la fiche
 * client n'affichent l'exclusion que si une demande peut réellement partir.
 *
 * @param {Object|null|undefined} restaurantConfig - Configuration du restaurant
 * @return {boolean} Vrai si la demande d'avis est activée
 */
export const isReviewRequestEnabled = (restaurantConfig) => restaurantConfig?.reviewSettings?.enabled === true;

/** Libellé de l'interrupteur, commun à la réservation et aux préférences de la fiche client. */
export const REVIEW_EXCLUSION_LABEL = 'Ne pas demander d\'avis';

/** Libellé court du badge affiché sur la fiche client et dans les listes. */
export const REVIEW_EXCLUSION_BADGE_LABEL = 'Pas d\'avis';

/** Icône de l'exclusion, commune à la fiche client et à la réservation. */
export const REVIEW_EXCLUSION_ICON = 'mdi:star-off';
